var render = function render(){
  var _vm$maintenanceDetail, _vm$maintenanceDetail2;
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('table', {
    staticClass: "table table-striped",
    staticStyle: {
      "border-bottom": "1px solid #dee2e6"
    }
  }, [_c('tbody', [_vm._m(0), _c('tr', [_c('td', [_vm._v("Job Code")]), _c('td', {
    staticClass: "font-medium"
  }, [_vm._v(_vm._s((_vm$maintenanceDetail = _vm.maintenanceDetailData.jobCode) !== null && _vm$maintenanceDetail !== void 0 ? _vm$maintenanceDetail : '-'))]), _c('td', [_vm._v("Job Name")]), _c('td', {
    staticClass: "font-medium"
  }, [_vm._v(_vm._s((_vm$maintenanceDetail2 = _vm.maintenanceDetailData.jobName) !== null && _vm$maintenanceDetail2 !== void 0 ? _vm$maintenanceDetail2 : '-'))])]), _c('tr', [_c('td', [_vm._v("Job Class")]), _c('td', {
    staticClass: "font-medium"
  }, [_vm._v(" " + _vm._s("".concat(_vm.maintenanceDetailData.jobClass.jobClassCode, " - ").concat(_vm.maintenanceDetailData.jobClass.jobClass)))]), _c('td', [_vm._v("Job Type")]), _c('td', {
    staticClass: "font-medium"
  }, [_vm._v(" " + _vm._s(_vm.maintenanceDetailData.jobType.jobTypeCode) + " ")])]), _c('tr', [_c('td', [_vm._v("Trigger")]), _c('td', {
    staticClass: "font-medium"
  }, [_vm._v(" " + _vm._s(_vm.maintenanceDetailData.trigger) + " ")]), _c('td', [_vm._v("Frequency")]), _c('td', {
    staticClass: "font-medium"
  }, [_vm._v(_vm._s(_vm.maintenanceDetailData.interval) + _vm._s(' ') + " " + _vm._s(_vm.maintenanceDetailData.trigger == 'CALENDAR' ? 'Month' : 'Hours'))])]), _c('tr', [_c('td', [_vm._v("Job Description")]), _c('td', {
    staticClass: "font-medium",
    attrs: {
      "colspan": "3"
    }
  }, [_vm._v(" " + _vm._s(_vm.maintenanceDetailData.jobType.description) + " ")])]), _c('tr', [_c('td', [_vm._v("Notes")]), _c('td', {
    staticClass: "font-medium",
    attrs: {
      "colspan": "3"
    }
  }, [_c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.maintenanceDetailData.notes)
    }
  }, [_vm._v(" " + _vm._s(_vm.maintenanceDetailData.notes || '-') + " ")])])])])])]);

}
var staticRenderFns = [function (){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('tr', [_c('td', [_vm._v("Ship Particular")]), _c('td', {
    staticClass: "font-medium"
  }, [_vm._v("-")]), _c('td', [_vm._v("Equipment")]), _c('td', {
    staticClass: "font-medium"
  }, [_vm._v("-")])]);

}]

export { render, staticRenderFns }